<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="bmTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("apps.ghistory") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
              {{ $t("apps.gticketchain") }}
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("apps.ghistory") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-4  mt-0">
                    <fieldset>
                      <div class="item">
                        <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                          <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                        </material-checkbox>
                        <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                          :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true"
                          month-name-format="long" :clearable="false" fluid :disabled="!time"
                          :text-input="textInputOptions" />
                      </div>
                    </fieldset>
                  </div>


                  <div class="col-lg-4 mt-2">
                    <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                    <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                      :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                      :clearable="false" fluid :disabled="!time" :text-input="textInputOptions" />
                  </div>

                  <div class="col-lg-4 mt-2">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("content.masset") }}</label>
                    <select v-model="maincat_search" class="form-select">
                        <option value="">{{ $t("content.optall") }}</option>
                        <option v-for="(item, index) in listprint" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                    </select>
                  </div>

                  <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("apps.gtransaction") }}</label>
                    <MultiSelect v-model="tx_search" :options="tx_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid @change="changeTx" />
                  </div>

                  <div v-if="tx_search.length !== tx_type.length && filterTx()" class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_mitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="3" variant="filled" fluid />
                  </div>

                  <div v-else class="col-lg-3 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnbiz") }}</label>
                    <MultiSelect v-model="type_search" :options="tx_nomitype" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="5" variant="filled" fluid />
                  </div>

                   <div class="col-lg-2 mt-3">
                    <label class="form-label ms-0">{{ $t("content.amnchannel") }}</label>
                    <MultiSelect v-model="channel_search" :options="channel_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid  />
                  </div>

                  <div class="col-lg-3  mt-1">
                    <fieldset>
                      <div class="item">
                        <span class="form-label m-0">{{ $t("content.status") }}</span>
                        <div class="d-inline-block mx-4">
                          <material-checkbox id="activewc" v-model="active_search" :checked="active_search"
                            name="autoSelect">{{ $t("content.activewc") }}
                          </material-checkbox>

                        </div>
                        <MultiSelect v-model="search_status" :options="status_type" optionLabel="name" filter
                          placeholder="" :maxSelectedLabels="4" variant="filled" fluid />
                      </div>
                    </fieldset>
                  </div>


                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.idcard") }}</label>
                    <MultiSelect v-model="idcard_search" :options="idcard_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid />
                  </div>

                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">OTP</label>
                    <MultiSelect v-model="otp_search" :options="otp_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid />
                  </div>

                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.autfingerprint") }}</label>
                    <MultiSelect v-model="represent_search" :options="represent_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid />
                  </div>

                  <div class="col-lg-3 mt-2">
                    <label class="form-label ms-0">{{ $t("content.outage2") }}</label>
                    <MultiSelect v-model="outage_search" :options="outage_type" optionLabel="name" filter placeholder=""
                      :maxSelectedLabels="2" variant="filled" fluid />
                  </div>

                  <div class="col-lg-3 mt-4">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input type="text" v-model="tk_search" />
                  </div>

                  <div class="col-lg-3 mt-4">
                    <label class="form-label ms-0">{{ $t("content.stockno") }}</label>
                    <material-input type="text" v-model="stockno_search" />
                  </div>

                  <div class="col-lg-3 mt-4">
                    <label class="form-label ms-0">{{ $t("content.migraref") }}</label>
                    <material-input type="text" v-model="miref_search" />
                  </div>

                  <div class="col-lg-3 mt-4">
                    <label class="form-label ms-0">Serial Number</label>
                    <material-input type="text" v-model="serial_search" />
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="loadDataHistoryApi"
                        :disabled="(!time && cusName_search === '' && tk_search === '' && serial_search === '' && miref_search === '' && stockno_search === '') || monthDiff()
                        || (time && start_date > end_date) || type_search.length === 0 || tx_search.length === 0 || search_status.length === 0 || channel_search.length === 0
                        || otp_search.length === 0 || represent_search.length === 0 || idcard_search.length === 0 || outage_search.length === 0">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ search }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-end align-items-center">
                    <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                    <div>
                      <material-button id="pdfBtn" color="info" variant="outline"
                        class="float-lg-start float-sm-end mb-0 me-2" :disabled="listhistory.length === 0"
                        @click="pdfGen">
                        <i class="material-icons material-symbols-outlined">picture_as_pdf</i> pdf
                      </material-button>
                      <material-button id="excelBtn" color="info" variant="outline"
                        cclass="float-lg-start float-sm-end mb-0 me-2" :disabled="listhistory.length === 0"
                        @click="XlsxGen">
                        <i class="material-icons material-symbols-outlined">table_rows</i> Excel
                      </material-button>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.amnticketold") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.migraref") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.masset") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>
                            {{ $t("content.actpawn3") }} /
                            {{ $t("content.actpawn4") }}
                          </th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnchannel") }}</th>
                          <th>{{ $t("content.assessor") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index"
                          :class="row.status !== 'TERMINATE' ? '' : 'bg-working'">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.cusName }}
                            </span>
                            <span v-else>
                              {{ row.tkCusName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                          <td class="text-sm font-weight-normal" :style="row.outage ? 'color:red' : ''">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} (ทำแทน,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                  {{ checkTransaction(row.type) }} (ทำแทน{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkShopRepresent(',',row)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} {{checkShopRepresent('-',row)}}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                  {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ,{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                   {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},{{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }}{{checkOutage(',',row.outage)}})
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="containsOnlyNumbers(row.initRefNumber)">
                                   {{ checkTransaction(row.type) }} ({{ $t("content.translost") }}{{checkOutage(',',row.outage)}})
                                </span>
                                <span v-else>
                                    {{ checkTransaction(row.type) }} {{checkOutage('-',row.outage)}}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.catName }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span
                              v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                              <span v-if="row.payOrReceive === row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else-if="row.type === 'INTEREST'">
                              <span v-if="row.payOrReceive !== row.roundInterest" style="color:blue">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.totalPay !== 0" style="color:red">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else-if="row.totalReceive !== 0" style="color:green">
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.payOrReceive) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.channel === 'SHOP'">
                              {{ $t("content.gchshop") }}
                            </span>
                            <span v-else>
                              LINE OA
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ checkProcess(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle" :title="chain"
                              @click="openListChain(row)">
                              <i class="material-icons material-symbols-outlined">arrow_forward</i>
                            </material-button>
                            <material-button color="dark" variant="outline" class="rounded-circle"
                              :title="t('buttons.printp')" @click="ticketGen(row)"
                              :disabled="row.type === 'REDEEM'
                                || (row.status === 'TERMINATE' && row.refNumber === '') || format_date(row.createDate) !== format_date(new Date())">
                              <i class="material-icons material-symbols-outlined">print</i>
                            </material-button>
                            <material-button color="secondary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.printpb')"
                              @click="backCoverGen(row)" :disabled="row.type === 'PAWN' || row.status === 'TERMINATE'">
                              <i class="material-icons material-symbols-outlined">description</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.replacetk')"
                              :disabled="row.status === 'TERMINATE' || row.latest" @click="replaceTicketGen(row)">
                              <i class="material-icons material-symbols-outlined">receipt</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnticketmanage')"
                              :disabled="row.type !== 'PAWN' || row.status === 'TERMINATE'" @click="openEdit(row)">
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="primary" class="float-lg-start float-sm-end mb-0"
                              data-bs-toggle="modal" data-bs-target="#newPawnListModal" id="newPawnModal"
                              v-show="false" />
                            <material-button color="dark" variant="outline" class="rounded-circle"
                              @click="onattachmenDialog(row)" :disabled="row.status === 'TERMINATE'"
                              :title="t('content.tupload')">
                              <i class="material-icons material-symbols-outlined">attach_file</i>
                            </material-button>
                            <material-button data-bs-toggle="modal" data-bs-target="#attachmentsModal" v-show="false"
                              id="attachmenDialog">
                            </material-button>

                            <!-- <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.canct')">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </material-button> -->
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="17" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header">
                          <td class="text-lg font-weight-bold text-end text-center" colspan="9">
                            <span v-if="listhistory.length > 0">
                              <b>{{ $t("content.gtotal") }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberString(totalQuantity) }}</b>
                            </span>
                          </td>

                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold" colspan="5"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 style="display: inline-block; width: auto">
                    {{ $t("apps.gticketchain") }}
                  </h5>
                  <div class="d-flex justify-content-end align-items-center">
                    <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
                    <material-button v-for="(i, exp) in exportFile" :key="exp" :color="i.cl" variant="outline"
                      class="float-lg-start float-sm-end mb-0 me-2" :class="i.cs">
                      <i class="material-icons material-symbols-outlined">{{ i.ic }}</i>
                      {{ i.nm }}
                    </material-button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.trans") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.allprice") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listticketchain" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPageT - 1) * perPageT +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ทำแทน)
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ออนไลน์)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ออนไลน์)
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listticketchain.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="10" style="text-align: right">Total Rows : {{ totalRows_sT }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listticketchain.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageT" :total-items="totalRowsT"
                          :items-per-page="perPageT" @click="onClickHandlerT" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <!-- Search Customer Dialog -->
          <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <!-- <th style="width: 100px">{{ $t("content.ccode") }}</th> -->
                            <th>#</th>
                            <th>{{ $t("content.cnameth") }}</th>
                            <th>{{ $t("content.cnameen") }}</th>
                            <th>{{ $t("content.docno") }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerAfListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(row, index) in customerlist" :key="index" @click="selectCusAf(row)">
                            <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                            <td>{{ row.nameTh }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td colspan="2">{{ row.docNumber }}</td>
                          </tr>
                          <tr v-if="customerlist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>

                <div class="modal-footer">
                  <pre></pre>
                  <div style="display: flex; justify-content: flex-end">
                    <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                      <div class="project-container">
                        <div class="example-one">
                          <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                            :items-per-page="perPageC" @click="onClickHandlerC" />
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <!-- Detail Modal -->
          <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                  <div style="display: flex; justify-content: flex-end">
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                      </div>
                    </div>
                    <div>
                      <div class="d-inline-block mx-4">
                        <material-checkbox id="infocus" v-model="fcusdt" :checked="fcusdt">
                          {{ $t("content.infofcus") }}
                        </material-checkbox>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-lg-6 mt-2">
                      <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false"
                        style="max-width: 520px">
                        <div class="carousel-indicators" id="demo1">
                        </div>
                        <div class="carousel-inner">
                          <ul className="list-unstyled">
                            <li v-for="(item, index) in images.length" :key="index">
                              <span v-if="index === 0">
                                <div class="carousel-item active">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                              <span v-else>
                                <div class="carousel-item">
                                  <vue-image-zoomer :regular="images[index].src" img-class="img-fluid"
                                    class="d-block w-100" :zoom-amount="3" :click-zoom="true" close-pos="top-right"
                                    message-pos="top" />
                                </div>
                              </span>
                            </li>
                          </ul>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                          data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-lg-6 mt-2">
                      <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                        <div>
                          <table class="table table-sm table-borderless">
                            <tbody>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                                  <span v-if="workcaseDetail.tkRefNumber !== ''">
                                    {{ workcaseDetail.tkRefNumber }} &nbsp;
                                    <span @click='copyBtn()' style="cursor: pointer">
                                      <i class="inline-icon material-icons">content_copy</i>
                                    </span>
                                  </span>
                                  <span v-else>-</span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                                  <span v-if="workcaseDetail.deposit" style="color:green;">
                                    {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                  {{ checkTransaction(workcaseDetail.transactionType) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                                  <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                                    {{ tk_status }}
                                  </span>
                                  <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                    || workcaseDetail.status === 'BREAKING'" style="color:red;">
                                    <span v-if="workcaseDetail.status === 'BREAKING'">
                                      {{ tk_status }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                        workcaseDetail.lotNumber }})
                                    </span>
                                    <span v-else>
                                      {{ tk_status }}
                                    </span>
                                  </span>
                                  <span v-else>
                                    {{ tk_status }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount === 0">
                                <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                                  format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.amnduedate") }} :
                                  <span style="color:red;">
                                    {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                                      format_date(workcaseDetail.postponeDate) }})
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.postponeCount !== 0">
                                <td class="fs-14 text-bold" colspan="2">
                                  {{ $t("content.deferpast") }} :
                                  <span @click='NewTab()' style="text-decoration: underline;color:red; cursor: pointer">
                                    {{ workcaseDetail.postponeCount }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.monthlyprofn") }} : {{
                                    formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                                  <span style="color:red;">
                                    ({{ format_date(new Date()) }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.currentprof") }} :
                                  <span style="color:red;">
                                    {{ formatNumberDecimalString(int_cal) }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">
                                  {{ $t("content.ttprointerest") }} :
                                  <span
                                    v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">
                                  {{ $t("content.periodpromotion") }} :
                                  <span v-if="workcaseDetail.promotionDuration === 0">
                                    -
                                  </span>
                                  <span style="color:blue;" v-else>
                                    {{ workcaseDetail.promotionDuration }} เดือน
                                  </span>
                                </td>
                              </tr>

                              <template v-if="!fcusdt && workcaseDetail.interestPromotion !== 0 && promotionDetail !== null">
                                <tr v-for="(item, index) in promotionDetail.interests" :key="item.id">
                                  <div v-if="item.promotion" class="fs-14 text-bold" style="display: flex; width: 100%;">
                                    <!-- คอลัมน์ซ้าย: กำหนดความกว้างคงที่เพื่อให้ย่อหน้าตรงกัน -->
                                    <div style="width: 70px;">
                                      เดือนที่ {{ index + 1 }} :
                                    </div>
                                    <!-- คอลัมน์ขวา: แสดงตัวเลขสีน้ำเงิน -->
                                    <div style="color:blue;">
                                      {{ item.interestVal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                    </div>
                                  </div>
                                </tr>
                              </template>

                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkVolNo }}
                                  </span>
                                  &nbsp;{{ $t("content.amnno") }}
                                  <span style="color:blue;">
                                    {{ workcaseDetail.tkNo }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.periodpawnn") }} :
                                  <span style="color:blue;">
                                    {{ int_period }} เดือน
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                                  {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                                  <span v-if="workcaseDetail.transactionType === 'PAWN'">
                                    {{ formatNumberDecimalString(0) }}
                                  </span>
                                  <span v-else>
                                    {{ formatNumberDecimalString(workcaseDetail.pawnValue) }} 
                                    <span style="color:red;">
                                      ({{format_date(transdate_prv) }})
                                    </span>
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}
                                  :
                                  {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                                </td>
                              </tr>
                              <tr v-else>
                                <td class="fs-14 text-bold" colspan="2">{{ $t("content.amnanalysval") }} :
                                  {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                                  </span>
                                  <span v-else style="color:red;">
                                    มี ({{ workcaseDetail.lostCount }})
                                  </span>
                                </td>
                                <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                                  <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                                  </span>
                                  <span v-else style="color:red;">
                                    {{ workcaseDetail.lostRefNumber }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                  <span style="color:red;">
                                    {{workcaseDetail.customerInfo.name}}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="workcaseDetail.changeName && !fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                  <span style="color:red;">
                                    {{ af_changename }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                  <span v-if="workcaseDetail.outage" style="color:red">
                                    {{ $t("content.yes") }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ $t("content.no") }}
                                  </span>
                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                                  <span v-if="workcaseDetail.ticket.locationName !== null">
                                    {{ workcaseDetail.ticket.locationName }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                                  <span v-if="workcaseDetail.ticket.stockNumber !== null">
                                    {{ workcaseDetail.ticket.stockNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                              <tr v-if="!fcusdt">
                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                                  <span v-if="workcaseDetail.migrateRefNumber !== null">
                                    {{ workcaseDetail.migrateRefNumber }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>

                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <span v-if="!fcusdt">
                            <span v-if="listinfo.length !== 0">
                              <table class="table table-sm table-borderless" 
                                    style="width: 100%; table-layout: fixed; border-collapse: collapse; border: 0 !important;">
                                
                                <colgroup>
                                  <col style="width: auto;">
                                  <col style="width: 160px;"> <!-- ปรับตามความยาวตัวเลข -->
                                </colgroup>

                                <!-- เพิ่ม style ลบ border ที่ tbody เพื่อความชัวร์ -->
                                <tbody style="border: 0 !important;">
                                  <tr>
                                    <!-- ลบ border-top แบบเจาะจงที่ตัว td หัวข้อ -->
                                    <td colspan="2" class="fs-14 text-bold" 
                                        style="border: 0 !important; border-top: 0 !important; padding-top: 15px;">
                                      <span style="text-decoration:underline;">
                                        {{ $t("content.amnassetdetail") }}
                                      </span>
                                    </td>
                                  </tr>

                                  <tr v-for="(row, index) in listinfo" :key="index">
                                    <td class="fs-14 text-bold" 
                                        style="word-break: break-word; white-space: normal; vertical-align: top; text-align: left; padding-right: 5px; border: 0 !important;">
                                      {{ formatNumberString(index + 1) }}. {{ row.remark }}
                                    </td>
                                    <td class="fs-12 text-bold" 
                                        style="vertical-align: top; text-align: right; white-space: nowrap; border: 0 !important;">
                                      <span style="color:blue;">
                                        {{ formatNumberDecimalString(row.newPawnValue) }} 
                                      </span> / {{ formatNumberDecimalString(row.fullValue) }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </span>
                            <span v-else>
                              <tr>
                                <td class="fs-14 text-bold">
                                  <span style="text-decoration:underline;">
                                    {{ $t("content.amnassetdetail") }}
                                  </span>
                                  : -
                                </td>
                              </tr>
                            </span>
                          </span>
                          <span v-else>
                            <table class="table table-sm table-borderless">
                              <tbody>
                                <tr>
                                  <td class="fs-14 text-bold">
                                    <span style="text-decoration:underline;">
                                      {{ $t("content.amngrandtotal") }}
                                    </span> :
                                    {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }} + {{
                                      formatNumberDecimalString(int_cal) }} =
                                    <span style="color:blue;">
                                      {{ formatNumberDecimalString(Number(workcaseDetail.newPawnValue) +
                                        Number(int_cal))
                                      }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </span>



                        </div>
                      </div>
                    </div>
                  </div>
                  <hr v-if="paymentE !== ''" />
                  <div class="col-12 mt-2" v-if="paymentE !== ''">
                    <div class="fs-14 text-bold">
                      <span style="text-decoration:underline;">
                        {{ $t("content.amnfinanceinfo") }}
                      </span>
                    </div>
                    <pre></pre>
                    <div class="row">
                      <div class="table-responsive">
                        <table class="table table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th>#</th>
                              <th>{{ $t("content.ticketno") }}</th>
                              <th>{{ $t("content.amnbiz") }}</th>
                              <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnincome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnoutcome") }}
                                </span>
                              </th>
                              <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.fee") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>

                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amncheque") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncash") }}
                                </span>
                              </th>
                              <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbanktransfer") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amncreditcard") }}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th colspan="3"></th>
                              <th style="background-color:#dfffdd;"></th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#dfffdd;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th colspan="2" style="background-color:#dfffdd;"></th>
                              <th style="background-color:#fecac7;"></th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_mobile") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#fecac7;">
                                <span style="color:black;">
                                  {{ $t("content.amntransfer_promt_taxid") }}
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  {{ $t("content.amnbankacc") }}
                                </span>
                              </th>
                              <th class="align-top text-center" style="background-color:#CFEBFD;">
                                <span style="color:black;">
                                  QR Code
                                </span>
                              </th>
                              <th style="background-color:#CFEBFD;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in paymentE.workCases" :key="index">
                              <template v-if="row.ticket !== null">
                                <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                                </td>
                                <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                                <td class="text-sm font-weight-normal text-center">{{
                                  checkTransaction(row.transactionType) }}</td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[0].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[1].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[6].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[2].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[3].receive > 0" style="color:green;">
                                    {{ formatNumberDecimalString(payment_l[3].receive) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[0].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[1].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[4].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[4].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[5].pay > 0" style="color:red;">
                                    {{ formatNumberDecimalString(payment_l[5].pay) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[0].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[1].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[6].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                                <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                  :rowspan="paymentE.workCases.length">
                                  <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                    {{ formatNumberDecimalString(payment_l[2].fee) }}
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Add New List in Pawn Ticket Dialog -->
          <div id="newPawnListModal" class="modal fade" aria-labelledby="newPawnListModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">{{ $t("content.amnsplitlist") }} </h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <!-- <div id="custom-target"></div> -->
                  <fieldset>
                    <div class="row">
                      <div class="col-lg-4">
                        <label class="form-label ms-0">{{
                          $t("content.amnassetgroup")
                        }}</label>
                        <select v-model="collect_detail.mainCatUid" class="form-select" disabled>
                          <option value="0" selected disabled>{{ $t("content.select") }}</option>
                          <option v-for="(item, index) in listprint" :value="item.uid" :key="index">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                      <div class="col-lg-8">
                        <label class="form-label ms-0">
                          {{ $t("content.amnassetgroup") }}
                          <span v-if="typesNew.length > 0">
                            ({{ textt }})
                          </span>
                        </label>
                        <div ref="parentRef" class="cs-auto-input">
                          <input id="inp" v-model="filterText" ref="input" placeholder="ค้นหาประเภททรัพย์..."
                            class="form-control auto-input-search" list="assetOptions" @input="newformatinput"
                            autocomplete="off" type="search" :disabled="collect_detail.uid === ''">
                          <ul id="myList" v-if="dataList.length > 0 && filterText.length > 0" ref="list"
                            class="data-list" :style="`width: ${childWidth}px !important;`" @scroll="handleScroll">
                            <li v-for="(item, index) in dataList" :key="index" @click="selection(item)">
                              <a>{{ item.datailt }}</a>
                            </li>
                            <li v-if="loading_l">Loading...</li>
                            <p v-if="dataList.length" id="load-more" :class="loadMoreStatus"></p>
                          </ul>
                        </div>
                      </div>

                      <div class="row flex flex-wrap p-fluid">

                        <div class="flex-auto col-lg-4">
                          <label class="form-label ms-0">{{ $t("content.amnqtyunittick") }} </label>
                          <InputNumber v-model="collect_detail.quantity" autocomplete="off" fluid disabled />
                        </div>

                        <div class="flex-auto col-lg-2">
                          <label class="form-label ms-0">{{ $t("content.munit") }}</label>
                          <select v-model="collect_detail.unitUid" class="form-select" @change="setRemark"
                            :disabled="collect_detail.uid === ''">
                            <option value="0" selected disabled>{{ $t("content.select") }}</option>
                            <option v-for="(item, index) in listunit" :value="item.uid" :key="index">
                              {{ item.name }}
                            </option>
                          </select>
                        </div>

                        <div class="flex-auto col-lg-6">
                          <label class="form-label ms-0">Serial Number</label>
                          <material-input id="serialPawn" v-model="collect_detail.serialNumber" autocomplete="off"
                            @update:modelValue="setRemark()" :disabled="collect_detail.uid === ''" />
                        </div>

                      </div>

                      <div class="row flex flex-wrap p-fluid">
                        <div class="flex-auto col-lg-4">
                          <label class="form-label ms-0">{{ $t("content.amnhdweightall") }}</label>
                          <InputNumber v-model="collect_detail.weight" :minFractionDigits="0" :maxFractionDigits="2"
                            autocomplete="off" fluid disabled />
                        </div>


                        <div class="col-lg-4">
                          <label class="flex-auto form-label ms-0">{{ $t("content.amnanalysval") }}</label>
                          <InputNumber v-model="collect_detail.newPawnValue" :minFractionDigits="0"
                            :maxFractionDigits="2" autocomplete="off" fluid disabled />

                        </div>

                        <div class="flex-auto col-lg-4">
                          <label class="form-label ms-0">{{ $t("content.amnmaxval") }}</label>

                          <InputNumber v-model="collect_detail.fullValue" :minFractionDigits="0" :maxFractionDigits="2"
                            autocomplete="off" fluid disabled />
                        </div>
                      </div>

                      <div class="col-12 mt-2">
                        <div class="d-flex align-items-center mb-1">
                          <label class="form-label ms-0 mb-0 me-3">
                            {{ $t("content.amnoldmessage") }}
                          </label>
                        </div>
                        <Textarea rows="2" v-model="oldremark" class="w-100" disabled />
                      </div>

                      <div class="col-12 mt-3">
                        <div class="d-flex align-items-center mb-1">
                          <label class="form-label ms-0 mb-0 me-3">
                            {{ $t("content.orderinfo") }} ({{ $t("content.shmorder") }})
                          </label>
                        </div>
                        <Panel>
                          <div class="table-responsive">
                            <table class="table table-sm table-hover">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>{{ $t("content.amnassetgroup") }}</th>
                                  <th>{{ $t("content.amnweightval") }}</th>
                                  <th>{{ $t("content.amnqtyunit") }}</th>
                                  <th>{{ $t("content.amnanalysval") }}</th>
                                  <th>{{ $t("content.amnmaxval") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, index) in listinfo" :key="index">
                                  <td class="text-sm font-weight-normal">{{ formatNumberString(index + 1) }}</td>
                                  <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                                  <td class="text-sm font-weight-normal">
                                    <span style="text-decoration:underline;color:red;">
                                      {{ formatNumberDecimalString(row.weight) }}
                                    </span>
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    <span style="text-decoration:underline;color:red;">
                                      {{ formatNumberString(row.quantity) }}
                                    </span>
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    <span style="text-decoration:underline;color:red;">
                                      {{ formatNumberDecimalString(row.pawnValue) }}
                                    </span>
                                  </td>
                                  <td class="text-sm font-weight-normal">
                                    <span style="text-decoration:underline;color:red;">
                                      {{ formatNumberDecimalString(row.fullValue) }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Panel>
                      </div>

                      <div class="flex flex-wrap p-fluid mt-2">
                        <div class="flex-auto col-lg-4">
                          <label class="flex-auto form-label ms-0">
                            {{ $t("content.ticketdetail") }}
                          </label>

                          <small class="form-label ms-2" style="color:red;">
                            <span @click="selectFlaw()" style="text-decoration: underline;color:red; cursor: pointer">
                              {{ $t("content.defect") }}
                            </span>
                          </small>
                        </div>
                        <div class="card mb-3" v-if="openFlaw">
                          <Panel>
                            <template #header>
                              <span> <label class="flex-auto form-label ms-0">{{ $t("content.select") }} {{
                                $t("content.defect") }}</label></span>
                            </template>
                            <template #icons>
                              <Button severity="secondary" rounded text class="btnClose" @click="selectFlaw()">
                                <i class="material-icons material-symbols-outlined">close</i>
                              </Button>
                            </template>
                            <template #footer>
                              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                                <button class="btn btn-primary btn-sm" type="button" @click="flawSelection()"> {{ save
                                }}</button>
                              </div>
                            </template>
                            <div class="grid-container">
                              <div v-for="option in listflaw" :key="option" class="d-inline-block mx-4">
                                <input type="checkbox" v-model="option.chk" :check="option.chk" /><label
                                  class="flex-auto form-label ms-2">
                                  {{ option.name }}</label>
                              </div>
                            </div>

                          </Panel>
                        </div>
                        <material-input v-model="collect_detail.remark" autocomplete="off" class="w-100"
                          :disabled="collect_detail.uid === ''" />
                      </div>
                    </div>
                  </fieldset>
                  <pre></pre>
                  <div class="row mt-4 no-gutters">
                    <div class="col-6 d-flex justify-content-end align-items-center">
                    </div>

                    <div class="col-6 d-flex justify-content-end align-items-center">
                      <button type="button" class="btn btn-primary" :disabled="(collect_detail.mainCatUid === '' || collect_detail.mainCatUid === '0')
                        || filterText === '' || collect_detail.remark.trim() === '' || collect_detail.unitUid === '0'"
                        @click="update">
                        {{ save }}
                      </button>
                    </div>
                  </div>
                  <pre></pre>

                  <div class="me-2">
                    <h6>
                      <b>{{ $t("content.amnassetdatas") }}</b>
                    </h6>
                  </div>

                  <div class="row mt-4">
                    <div class="table-responsive">
                      <table class="table table-flush">
                        <thead class="thead-light">
                          <tr>

                            <th>#</th>
                            <th>{{ $t("content.amndatetime") }}</th>
                            <th>{{ $t("content.amnbiz") }}</th>
                            <th>{{ $t("content.amnassetgroup") }}</th>
                            <th>{{ $t("content.amnweightval") }}</th>
                            <th>{{ $t("content.amnqtyunit") }}</th>
                            <th>{{ $t("content.amnanalysval") }}</th>
                            <th>{{ $t("content.amnmaxval") }}</th>

                            <th>{{ $t("content.act") }}</th>
                          </tr>
                        </thead>

                        <tbody v-for="(row, index) in listQ02D" :key="index" :data-group-index="index">
                          <tr class="group-id-ticket" :class="row.st == 'finished' ? '' : 'bg-working'">
                            <td class="text-sm font-weight-normal">{{ formatNumberString(index + 1) }}</td>
                            <td class="text-sm font-weight-normal">{{ format_datetime(listQ02E.createDate) }}</td>
                            <td class="text-sm font-weight-normal">{{ checkTransaction(listQ02E.type) }}</td>
                            <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight)
                            }}
                            </td>
                            <td class="text-sm font-weight-normal">{{ formatNumberString(row.quantity) }}</td>
                            <td class="text-sm font-weight-normal">
                              <span v-if="listQ02E.type !== 'INC_PRINCIPLE' && listQ02E.type !== 'DEC_PRINCIPLE'">
                                {{ formatNumberDecimalString(row.newPawnValue) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.tmpNewPawnValue) }}
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal">{{
                              formatNumberDecimalString(row.fullValue) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              <material-button color="info" variant="outline" class="rounded-circle"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="edit"
                                @click="setItemDetail(row)">
                                <i class="material-icons material-symbols-outlined">edit</i>
                              </material-button>
                              <!-- <material-button color="danger" variant="outline" class="rounded-circle"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="cancel" @click="onDelete(row)">
                                <i class="material-icons material-symbols-outlined">delete</i>
                              </material-button> -->
                            </td>
                          </tr>
                          <tr v-for="(j, set1) in row.remarkL" :key="set1">
                            <td class="text-sm font-weight-normal text-end" colspan="3">
                              <span style="text-decoration:underline">
                                {{ $t("content.amnassetdetail") }}
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal" colspan="7">
                              <span style="color:red">
                                <b>{{ j.val }}</b>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Add File Dialog -->
          <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 800px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title"> {{ tk_cusname }}
                    ({{ $t("content.ticketno") }} : {{ tk_ref }}) </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeattach">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <div class="row">
                      <div class="col-lg-12">
                        {{ $t("content.previmg") }} : {{ images.length }}
                      </div>
                    </div>
                    <pre></pre>
                    <div class="grid-containerP" v-if="images.length">
                      <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                        <td>
                          <div class="wrapper">
                            <figure width="100px" height="100px">
                              <img :src="item.src" class="img img-fluid" />
                            </figure>
                          </div>
                        </td>
                      </div>
                    </div>
                  </fieldset>
                  <hr />
                  <fieldset>
                    <div class="row">
                      <div class="col-lg-12">
                        {{ $t("content.insertimg") }} {{ preview_list.length }}/5
                      </div>
                      <pre></pre>
                      <div class="col-lg-12">
                        <div class="d-flex align-items-center mb-1">
                        </div>
                        <input type="file" accept="image/*" @change="previewMultiImage" class="form-control-file"
                          id="my-file" :disabled="preview_list.length >= 5" />
                      </div>
                    </div>
                    <pre></pre>
                    <div class="grid-containerP" v-if="preview_list.length">
                      <div v-for="item, index in preview_list" :key="index" class="d-inline-block mx-2">
                        <td>
                          <div class="wrapper">
                            <figure width="100px" height="100px">
                              <img :src="item" class="img img-fluid" />
                            </figure>
                            <button type="button" class="btn myLayer" style="color: red;" :title="t('buttons.dele')"
                              @click="removeImage(item, index)">
                              <i i class="material-icons">close</i>
                            </button>
                          </div>
                        </td>
                      </div>
                    </div>

                  </fieldset>
                </div>

                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                    {{ cancel }}
                  </button>
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    :disabled="image_list.length <= 0" @click="uploadImg()">
                    {{ save }}
                  </button>
                </div>
              </div>
            </div>
          </div>


          <!-- Search Sanction Dialog -->
          <div id="searchSanctionModal" class="modal fade" tabindex="-1" aria-labelledby="searchSanctionModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title text-center">
                    <span style="color:red;">
                      {{ $t('content.sanctionmsg') }} {{ $t('content.millegal') }}
                    </span>
                  </h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="preview-table">
                    <section class="panel">
                      <table class="table table-striped table-responsive">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{{ $t('content.serial') }}</th>
                            <th>{{ $t('content.refer') }}</th>
                            <th>{{ $t('content.docnum') }}</th>
                            <th>{{ $t('content.docdate') }}</th>
                            <th>{{ $t('content.criminal') }}</th>
                            <th>{{ $t('content.agency') }}</th>
                            <th>{{ $t('content.defect') }}</th>
                            <th>{{ $t('content.detail') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in wanninglist" :key="index">
                            <td class="text-sm font-weight-normal">
                              {{ formatNumberString(index + 1) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.serialNumber }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.reportBy }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.docNumber }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ format_date(row.docDate) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.caseNumber }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.source }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.flawMark }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              {{ row.remark }}
                            </td>
                          </tr>
                          <tr v-if="wanninglist.length === 0">
                            <td colspan="5" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
                <div class="modal-footer">
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import Modal from 'bootstrap/js/dist/modal';
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import Textarea from 'primevue/textarea';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue"
import InputNumber from 'primevue/inputnumber';
import Panel from 'primevue/panel';
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MultiSelect from 'primevue/multiselect';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"


import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useCategoryStore } from '@/stores/category'
import { useInterestStore } from '@/stores/interest'
import { useUniteStore } from '@/stores/unit'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useFlawtStore } from '@/stores/flaw'
import { useCollateralStore } from '@/stores/collateral'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useDocumentStore } from '@/stores/document'
import { useTicketImageStore } from '@/stores/ticketimage'
import { useSanctionAssetsStore } from '@/stores/sanctionassets'
import { useShopCatOrderStore } from '@/stores/shopcatorder'
import { useShopStore } from '@/stores/shop'
import { useDepositStore } from '@/stores/deposit'
import { routerViewLocationKey } from 'vue-router';

const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storec = useCategoryStore()
const storei = useInterestStore()
const storeu = useUniteStore()
const storep = usePaymentGroupStore()
const storetf = useFlawtStore()
const storecl = useCollateralStore()
const storeca = useCashAccountStore()
const stored = useDocumentStore()
const storeti = useTicketImageStore()
const storeass = useSanctionAssetsStore()
const storeco = useShopCatOrderStore()
const storesh = useShopStore()
const storedepo = useDepositStore()


const { t } = useI18n();
const swal = inject("$swal");


const exportFile = reactive([
  {
    cl: "info",
    cs: "me-2",
    ic: "picture_as_pdf",
    nm: "pdf",
    ac: "",
  },
  {
    cl: "info",
    cs: "",
    ic: "table_rows",
    nm: "excel",
    ac: "",
  },
]);


const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const chain = computed(() => t('buttons.seed') + t("apps.gticketchain"));
const copy = computed(() => t("buttons.copyData"));
const search = computed(() => t("buttons.sear"));
const save = computed(() => t("buttons.save"));

const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val);
};

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
  format: 'dd/MM/yyyy HH:mm'
};

const tx_type = ref([
  { name: t("content.cintrate1"), code: 'NORMAL' },
  { name: t("content.transmig"), code: 'MIGRATION' },
]);

const tx_mitype = ref([
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
]);

const tx_nomitype = ref([
  { name: t("content.actpawn1"), code: 'PAWN' },
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
  { name: t("content.actpawn5"), code: 'REDEEM' },
]);

const status_type = ref([
  { name: t("content.status_finish"), code: 'FINISH' },
  { name: t("content.status_freeze"), code: 'FREEZE' },
  { name: t("content.status_termi"), code: 'TERMINATE' },
  { name: t("content.status_breaking"), code: 'BREAKING' },
]);

const channel_type = ref([
  { name: t("content.gchshop"), code: 'SHOP' },
  { name: 'LINE OA', code: 'LINE_LIFF' },
]);

const idcard_type = ref([
  { name: t("content.usecard"), code: 'YES' },
  { name: t("content.donusecard"), code: 'NO' },
]);

const otp_type = ref([
  { name: t("content.useotp"), code: 'YES' },
  { name: t("content.donuseotp"), code: 'NO' },
]);

const represent_type = ref([
  { name: t("content.userepresent"), code: 'YES' },
  { name: t("content.donuserepresent"), code: 'NO' },
]);

const outage_type = ref([
  { name: t("content.useoutage"), code: 'YES' },
  { name: t("content.donuseoutage"), code: 'NO' },
]);


const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageT = ref(1);
const totalRowsT = ref(1);
const perPageT = ref(30);
const totalRows_sT = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')


const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const type_search = ref('');
const serial_search = ref('');
const search_status = ref('');
const tx_search = ref('');
const miref_search = ref('');
const stockno_search = ref('');
const active_search = ref(false);
const channel_search = ref('');
const maincat_search = ref('');
const idcard_search = ref('');
const otp_search = ref('');
const represent_search = ref('');
const outage_search = ref('');


const listprint = ref([]);
const listhistory = ref([]);
const listticketchain = ref([]);
const listinfo = ref([]);
const customerlist = ref([])
const info_cat = ref('');
const workcaseDetail = ref(null);
const chain_uid = ref('');
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const time = ref(false);
const tk_ref = ref('');
const tk_cusname = ref('');
const int_period = ref('');
const fcusdt = ref(false);
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);


const images = ref([])
const images_l = ref([])
const shop_detail = ref({})
const shop_info = ref(null)
const payment_l = ref([])
const loading = ref(false);
const listunit = ref([]);
const listflaw = ref([]);
const oldremark = ref("");
const dataList = ref([]);
const loading_l = ref(false);
const showSuggestions = ref(false);
const limit = 10;
const page_s = ref(0);
const page_e = ref(10);
const filterText = ref("");
const filterInput = ref("");
const typesNew = ref([]);
const selected = ref("");
const textt = ref("");
const Listdata = ref([]);
const types = ref([]);
const openFlaw = ref(false);
const uid_edit = ref('');
const listQ02D = ref([]);
const listQ02E = ref([]);
const wanninglist = ref([]);
const tplist = ref([])


const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);



// infinite scroll
var input = (ref < HTMLInputElement) | (null > null);
const parentRef = ref(null);
const list = ref(null);
const parentWidth = ref(0);
const childWidth = ref(0);



const collect_detail = ref({
  uid: '',
  ticketUid: '',
  mainCatUid: 'no',
  mainCatCode: '',
  mainCatName: '',
  categoryUid: '',
  categoryCode: '',
  categoryName: '',
  weight: '',
  pawnValue: '',
  newPawnValue: '',
  tmpPawnValue: '',
  tmpNewPawnValue: '',
  fullValue: '',
  diamondQuantity: '',
  quantity: '',
  unitUid: 'no',
  unitName: '',
  remark: '',
  collateralGroupUid: '',
  version: '',
  serialNumber: '',
  priorityCatUid: '',
  priorityCatCode: '',
  priorityCatName: '',
});


const thumb_id = ref("");
const thumb = ref(null);
const preview = ref("");
const preview_list = ref([])
const image_list = ref([])
const count_success = ref(0);
const err_msg = ref("");

const listcat_order = ref([]);
const paymentGDetail = ref(null);
const regex = /data:.*base64,/
const mimeType = ref("");
const thumb_name = ref("");

const workcaseDetail_prv = ref(null);
const promotionDetail = ref(null);

const onClickHandler = (page) => {
  updatePagination()
};


const onClickHandlerT = (page) => {
  updatePaginationT()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};



const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}



async function previewMultiImage(event) {
  var input = event.target;
  var count = input.files.length;
  var index = 0;
  if (input.files) {
    while (count--) {
      thumb_name.value = ""
      mimeType.value = ""
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
      thumb_name.value = 'ticketimg_' + today
      if (event.target.files[0].type === "image/jpeg") {
        thumb_name.value = thumb_name.value + ".jpg"
        mimeType.value = "image/jpeg"
      } else if (event.target.files[0].type === "image/png") {
        thumb_name.value = thumb_name.value + ".png"
        mimeType.value = "image/png"
      } else if (event.target.files[0].type === 'application/pdf') {
        thumb_name.value = thumb_name.value + ".pdf"
        mimeType.value = "application/pdf"
      }
      image_list.value.push({ filedt: await toBase64(input.files[index]), fname: thumb_name.value, ftype: mimeType.value })
      preview_list.value.push(URL.createObjectURL(input.files[index]));
      index++;
    }
  }
}

async function removeImage(image, index) {
  preview_list.value.splice(index, 1);
  image_list.value.splice(index, 1);
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.replace('data:', '')
    .replace(/^.+,/, ''));
  reader.onerror = reject;
});

async function onattachmenDialog(item) {
  thumb.value = null
  preview.value = ''
  preview_list.value = []
  image_list.value = []
  uid_edit.value = ''
  workcaseDetail.value = null
  tk_ref.value = ''
  tk_cusname.value = ''
  images.value = []
  images_l.value = []

  document.getElementById("my-file").value = null;
  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value.ticket))
    images_l.value = workcaseDetail.value.ticket.images
    // console.log('images_l : ' + JSON.stringify(images_l.value))
    setFileGallery()
    uid_edit.value = workcaseDetail.value.ticket.uid
    tk_ref.value = item.refNumber
    if (item.changeName) {
      tk_cusname.value = item.customerName
    } else {
      tk_cusname.value = item.tkCustomerName
    }
  }
}


async function uploadImg() {
  count_success.value = 0
  for (let i = 0; i < image_list.value.length; i++) {
    await addfileApi(image_list.value[i])
  }
  document.getElementById("closeattach").click();
  if (count_success.value === 0) {
    swal("เพิ่มรูปในตั๋วไม่สำเร็จ", err_msg.value, "error");
  } else {
    swal("บันทึกสำเร็จ", Number(count_success.value) + "/" + image_list.value.length + " ไฟล์", "success");
  }
}


const getshopInfo = async (val) => {
  shop_detail.value = {}
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data
        type_search.value = tx_nomitype.value
        search_status.value = status_type.value
        tx_search.value = tx_type.value
        channel_search.value = channel_type.value
        idcard_search.value = idcard_type.value
        otp_search.value = otp_type.value
        represent_search.value = represent_type.value
        outage_search.value = outage_type.value
        await loadDataPrintApi()
        await checksessionStorage()
      }
    }
  }
}

getshopInfo()


const checksessionStorage = async () => {
  const data = sessionStorage.getItem('historyPage');
  if (!data) return;

  const obj = JSON.parse(data);
  if (!obj) return;

  cancelBtn();
  time.value = true;
  start_date.value = new Date(obj.start_date);
  end_date.value = new Date(obj.end_date);
  search_status.value = [status_type.value[0]];

  const configMap = {
    1:  { txIdx: 0, typeIdx: 'all', src: 'nomi' },
    2:  { txIdx: 1, typeIdx: 'all', src: 'mi'   },
    3:  { txIdx: 0, typeIdx: [0],    src: 'nomi' },
    4:  { txIdx: 0, typeIdx: [1],    src: 'nomi' },
    5:  { txIdx: 0, typeIdx: [2],    src: 'nomi' },
    6:  { txIdx: 0, typeIdx: [3],    src: 'nomi' },
    7:  { txIdx: 0, typeIdx: [4],    src: 'nomi' },
    8:  { txIdx: 1, typeIdx: [0],    src: 'mi'   },
    9:  { txIdx: 1, typeIdx: [1],    src: 'mi'   },
    10: { txIdx: 1, typeIdx: [2],    src: 'mi'   },
    11: { txIdx: 0, typeIdx: [0, 2], src: 'nomi' },
    12: { txIdx: 0, typeIdx: [1, 3, 4], src: 'nomi' },
  };

  const nomiTypeMap = { 'PAWN': 0, 'INTEREST': 1, 'INC_PRINCIPLE': 2, 'DEC_PRINCIPLE': 3, 'REDEEM': 4 };
  const miTypeMap = { 'INTEREST': 0, 'INC_PRINCIPLE': 1, 'DEC_PRINCIPLE': 2 };

  if (configMap[obj.value]) {
    const cfg = configMap[obj.value];
    const source = cfg.src === 'nomi' ? tx_nomitype.value : tx_mitype.value;
    tx_search.value = [tx_type.value[cfg.txIdx]];
    type_search.value = cfg.typeIdx === 'all' ? source : cfg.typeIdx.map(i => source[i]);
  } 
  // --- CASE B: สำหรับ Value 13-17 (Identity / OTP / Represent) ---
  else if (obj.value >= 13 && obj.value <= 17) {
    
    // 1. จัดการ Outage & Channel (ใช้ .includes ช่วยให้อ่านง่าย)
    const isOutageGroup = ['outage', 'outage-migration'].includes(obj.channel);
    outage_search.value = [outage_type.value[isOutageGroup ? 0 : 1]];
    channel_search.value = [channel_type.value[obj.channel === 'line' ? 1 : 0]];

    // 2. จัดการ TX Type & Type Search (Nomi vs Mi)
    const isMigration = ['migration', 'outage-migration'].includes(obj.channel);
    tx_search.value = [tx_type.value[isMigration ? 1 : 0]];
    
    const source = isMigration ? tx_mitype.value : tx_nomitype.value;
    const typeIdx = isMigration ? miTypeMap[obj.type] : nomiTypeMap[obj.type];
    if (typeIdx !== undefined) type_search.value = [source[typeIdx]];

    // 3. จัดการ ID Card & OTP (13-16) และ Represent (17)
    const logicMap = {
      13: { id: 0, otp: 1 }, // ID & NO OTP
      14: { id: 0, otp: 0 }, // ID & YES OTP
      15: { id: 1, otp: 1 }, // NO ID & NO OTP
      16: { id: 1, otp: 0 }, // NO ID & YES OTP
    };

    if (logicMap[obj.value]) {
      const cfg = logicMap[obj.value];
      idcard_search.value = [idcard_type.value[cfg.id]];
      otp_search.value    = [otp_type.value[cfg.otp]];
    } else if (obj.value === 17) {
      represent_search.value = [represent_type.value[0]];
    }
  }
  sessionStorage.removeItem('historyPage');
  await loadDataHistoryApi();
}






const loadDataApi = async () => {

  let data = "";
  data = {
    uid: 0,
  };
  const payload = data;

  const response = await storec.categoryfullNameFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        Listdata.value = response.data.data.list;
        if (Listdata.value.length > 0) {
          types.value = [];
          checkdataMatch2(Listdata.value);
        }
      }
    }
  }
};





const loadDataUnitApi = async (val) => {

  let data = "";
  data = {
    index: 0,
    size: 100,
    name: '',
  };
  const payload = data;
  const response = await storeu.unitListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listunit.value = response.data.data.list;
      }
    }
  }


};



function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}


const onserachDate = () => {
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
};


const selectFlaw = () => {
  if (listflaw.value.length > 0) {
    if (openFlaw.value) {
      openFlaw.value = false
      if (listflaw.value.length > 0) {
        for (let i = 0; i < listflaw.value.length; i++) {
          listflaw.value[i].chk = false
        }
      }
    } else {
      openFlaw.value = true
    }
    // document.getElementById("defectsBtn").click();
    // console.log('listflaw : ' + JSON.stringify(listflaw.value))

  }
}

const flawSelection = () => {
  let fdt = ''
  if (listflaw.value.length > 0) {
    for (let i = 0; i < listflaw.value.length; i++) {
      if (listflaw.value[i].chk) {
        if (fdt === '') {
          fdt = listflaw.value[i].name
        } else {
          fdt = fdt + ' ' + listflaw.value[i].name
        }
      }
    }
    setRematkDetail()
    if (fdt !== '') {
      if (collect_detail.value.remark !== '') {
        collect_detail.value.remark = collect_detail.value.remark + ' ' + fdt
      } else {
        collect_detail.value.remark = fdt
      }
      if (collect_detail.value.serialNumber !== '') {
        setSerialDetail()
      }
    }
    selectFlaw()
  }

}

const setRemark = () => {
  setRematkDetail()
  if (collect_detail.value.serialNumber !== '') {
    setSerialDetail()
  }

}


const setRematkDetail = () => {
  let dt = ''
  if (collect_detail.value.mainCatUid !== 'no') {
    let ld = listprint.value.filter((c) => c.uid === collect_detail.value.mainCatUid);

    if (ld.length > 0) {
      if (ld[0].name !== 'อื่นๆ') {
        if (selected.value === '') {
          let sl = types.value.filter((c) => c.fullName.toLowerCase().indexOf(filterText.value.trim().toLowerCase()) >= 0);
          if (sl.length > 0) {
            selected.value = sl[0]
          }
        }
        if (selected.value !== '') {
          if (ld[0].l2Print) {
            if (selected.value.t2 !== '') {
              dt = selected.value.t2
            }

          }
          if (ld[0].l3Print) {
            if (selected.value.t3 !== '') {
              if (dt === '') {
                dt = selected.value.t3
              } else {
                dt = dt + ' ' + selected.value.t3
              }
            }

          }
          if (ld[0].l4Print) {
            if (selected.value.t4 !== '') {
              if (dt === '') {
                dt = selected.value.t4
              } else {
                dt = dt + ' ' + selected.value.t4
              }
            }

          }
          if (ld[0].l5Print) {
            if (selected.value.t5 !== '') {
              if (dt === '') {
                dt = selected.value.t5
              } else {
                dt = dt + ' ' + selected.value.t5
              }
            }

          }
          if (ld[0].l6Print) {
            if (selected.value.t6 !== '') {
              if (dt === '') {
                dt = selected.value.t6
              } else {
                dt = dt + ' ' + selected.value.t6
              }
            }
          }
        }

      } else {
        dt = filterText.value.trim()
      }
    }
    ;
  }



  if (collect_detail.value.quantity !== '0' && collect_detail.value.quantity !== '' && parseFloat(collect_detail.value.quantity) > 0) {
    if (dt === '') {
      dt = collect_detail.value.quantity
    } else {
      dt = dt + ' ' + collect_detail.value.quantity
    }

    if (collect_detail.value.unitUid !== '' && collect_detail.value.unitUid !== '0') {

      if (dt === '') {
        dt = filterUnit(collect_detail.value.unitUid)
      } else {
        dt = dt + ' ' + filterUnit(collect_detail.value.unitUid)
      }
    }
  }
  if (collect_detail.value.weight !== '' && collect_detail.value.weight !== '0' && parseFloat(collect_detail.value.weight) > 0) {
    let weight = collect_detail.value.weight
    if (dt === '') {
      dt = '(' + formatNumberDecimalString(Number(weight)) + ' กรัม)'
    } else {
      dt = dt + ' (' + formatNumberDecimalString(Number(weight)) + ' กรัม)'
    }
  }

  collect_detail.value.remark = dt

}


const setSerialDetail = () => {
  if (collect_detail.value.remark === '') {
    collect_detail.value.remark = '(' + collect_detail.value.serialNumber.trim() + ')'
  } else {
    collect_detail.value.remark = collect_detail.value.remark + ' (' + collect_detail.value.serialNumber.trim() + ')'
  }
}


async function checkdataMatch2(list) {
  let list2 = [];
  let t1 = "";
  let t2 = "";
  let t3 = "";
  let t4 = "";
  let t5 = "";
  let t6 = "";


  for (let i = 0; i < list.length; i++) {
    t1 = "";
    t2 = "";
    t3 = "";
    t4 = "";
    t5 = "";
    t6 = "";

    let text = list[i].fullName;
    text = text.split(">>");
    let count = text.length - 1;
    let newText = ''

    if (count > 0) {
      if (count === 1) {
        t1 = text[0];
        t2 = text[1];
        newText = text[1]
      } else if (count === 2) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        newText = text[1] + '>>' + text[2]

      } else if (count === 3) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        t4 = text[3];


        newText = text[1] + '>>' + text[2] + '>>' + text[3]

      } else if (count === 4) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        t4 = text[3];
        t5 = text[4];

        newText = text[1] + '>>' + text[2] + '>>' + text[3] + '>>' + text[4]

      } else if (count === 5) {

        t1 = text[0]
        t2 = text[1]
        t3 = text[2]
        t4 = text[3]
        t5 = text[4]
        t6 = text[5]

        newText = text[1] + '>>' + text[2] + '>>' + text[3] + '>>' + text[4] + '>>' + text[5]

      }
    }


    const obj = {
      uid: list[i].uid,
      code: list[i].code,
      detailt: newText.replaceAll(">>", " "),
      fullName: newText,
      datailt: newText,
      t1: t1,
      t2: t2,
      t3: t3,
      t4: t4,
      t5: t5,
      t6: t6,
    };
    list2.push(obj);
  }
  textt.value = "";
  if (list2.length > 0) {
    types.value = list2;
  }
}


async function selection(value) {
  selected.value = value;
  filterText.value = value.datailt;
  typesNew.value = [];
  textt.value = "";
  dataList.value = [];
  let ld = listprint.value.filter((c) => c.name.toLowerCase().indexOf(selected.value.t1.toLowerCase()) >= 0);
  if (ld.length > 0) {
    collect_detail.value.mainCatUid = ld[0].uid
    await getFlaw(ld[0].uid)
  } else {
    collect_detail.value.mainCatUid = '0'
  }
  setRemark()
}


async function newformatinput() {
  filterInput.value = "";
  page_s.value = 0;
  page_e.value = 20;
  typesNew.value = [];
  dataList.value = [];
  collect_detail.value.mainCatUid = '0'
  listflaw.value = []
  openFlaw.value = false
  let list = []
  if (filterText.value.trim().length > 0) {
    if (filterText.value.includes(">>")) {
      let text = filterText.value.replaceAll(/\s/g, "");
      text = text.split(">>");
      let count = text.length - 1;
      if (count > 0) {
        if (count === 1) {
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3
                .replaceAll(/\s/g, "")
                .toLowerCase()
                .includes(text[1].toLowerCase())
          );
          checkdataMatch(list);
        } else if (count === 2) {
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4
                .toLowerCase()
                .replaceAll(/\s/g, "")
                .includes(text[2].toLowerCase())
          );
          checkdataMatch(list);
        } else if (count === 3) {
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4.toLowerCase().replaceAll(/\s/g, "") ===
              text[2].toLowerCase() &&
              c.t5
                .replaceAll(/\s/g, "")
                .toLowerCase()
                .includes(text[3].toLowerCase())
          );
          checkdataMatch(list);
        } else if (count === 4) {
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4.toLowerCase().replaceAll(/\s/g, "") ===
              text[2].toLowerCase() &&
              c.t5.toLowerCase().replaceAll(/\s/g, "") ===
              text[3].toLowerCase() &&
              c.t6.toLowerCase().includes(text[4].toLowerCase())
          );
          checkdataMatch(list);
        }
      } else {
        filterInput.value = filterText.value.replaceAll(">>", "");
        list = types.value.filter(
          (c) =>
            c.t2.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t3.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t4.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t5.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t6.toLowerCase().includes(filterInput.value.toLowerCase())
        );
        checkdataMatch(list);
      }

    } else {
      if (
        filterText.value !== "" &&
        filterText.value !== undefined &&
        filterText.value !== null
      ) {

        filterInput.value = filterText.value.replaceAll(">>", "");

        var text = filterInput.value.trim().toLowerCase();
        var arr = text.match(/\S+/g);

        if (arr !== null) {

          list = types.value.filter((c) =>
            allAvailable(c.detailt.toLowerCase(), arr)
          );

          checkdataMatch(list);
        }
      }
    } if (list.length === 0) {
      let ld = listprint.value.filter((c) => c.name.toLowerCase().indexOf('อื่นๆ') >= 0);
      if (ld.length > 0) {
        collect_detail.value.mainCatUid = ld[0].uid
        selected.value = ''
        await getFlaw(ld[0].uid)
        setRemark()
      }
    }

  } else {
    typesNew.value = [];
    textt.value = "";
    setRemark()
  }

}


function allAvailable(str, matchArr) {
  return matchArr.every((item) => str.includes(item));
}


async function checkdataMatch(list) {
  let list2 = [];
  for (let i = 0; i < list.length; i++) {
    const obj = {
      datailt: list[i].datailt,
      t1: list[i].t1,
      t2: list[i].t2,
      t3: list[i].t3,
      t4: list[i].t4,
      t5: list[i].t5,
      t6: list[i].t6,
      detailt: list[i].detailt,
      fullName: list[i].fullName,
      uid: list[i].uid,
      code: list[i].code
    };
    list2.push(obj);
  }

  textt.value = "";
  if (list2.length > 0) {
    typesNew.value = list2;
    textt.value = "result : " + formatNumberString(list2.length) + " / " + formatNumberString(types.value.length);
    fetchData()
  }
}

async function getFlaw(uid) {
  listflaw.value = []
  let data = "";
  data = {
    categoryUid: uid,
  };
  const payload = data;
  const response = await storetf.flawListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let list = response.data.data.list;
        list.map(function (x) {
          x.chk = false
          return x
        });
        listflaw.value = list

      }
    }
  }
}

async function openEdit(item) {
  clearItem();
  uid_edit.value = ''
  workcaseDetail.value = null
  listQ02D.value = []
  listQ02E.value = []
  filterText.value = ''
  if (Listdata.value.length === 0) {
    await loadDataApi();
  }

  if (listprint.value.length === 0) {
    await loadDataPrintApi()
  }

  if (listunit.value.length === 0) {
    loadDataUnitApi()
  }
  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {
    // console.log('item : ' + JSON.stringify(item));
    listQ02E.value = item
    uid_edit.value = workcaseDetail.value.ticket.uid
    oldremark.value = workcaseDetail.value.remark
    listinfo.value = workcaseDetail.value.ticket.collateralInfo
    listQ02D.value = workcaseDetail.value.ticket.collaterals

    listQ02D.value.map(function (x) {
      x.chk = false
      x.remarkL = []
      return x
    });

    if (listQ02D.value.length > 0) {
      for (let i = 0; i < listQ02D.value.length; i++) {
        listQ02D.value[i].remarkL.push({ val: listQ02D.value[i].remark })
      }
    }
  
    document.getElementById("newPawnModal").click();
  }
}


async function setItemDetail(item) {
  clearItem();
  collect_detail.value = {
    uid: item.uid,
    ticketUid: item.ticketUid,
    mainCatUid: item.mainCatUid,
    mainCatCode: item.mainCatCode,
    mainCatName: item.mainCatName,
    categoryUid: item.categoryUid,
    categoryCode: item.categoryCode,
    categoryName: item.categoryName,
    weight: item.weight,
    pawnValue: item.pawnValue,
    fullValue: item.fullValue,
    diamondQuantity: item.diamondQuantity,
    quantity: item.quantity,
    unitUid: item.unitUid,
    unitName: item.unitName,
    remark: item.remark,
    collateralGroupUid: item.collateralGroupUid,
    serialNumber: item.serialNumber,
    version: item.version,
    newPawnValue: item.newPawnValue,
    tmpPawnValue: item.tmpPawnValue,
    tmpNewPawnValue: item.tmpNewPawnValue,
  };
  // console.log('setItemDetail : ' + JSON.stringify(collect_detail.value));
  filterText.value = item.categoryName
  if (collect_detail.value.mainCatUid !== '0') {
    await getFlaw(collect_detail.value.mainCatUid)
  }

  dataList.value = []
  selected.value = ''
  typesNew.value = []
  textt.value = ''


}
async function clearItem() {
  filterText.value = ''
  collect_detail.value = {
    uid: '',
    ticketUid: '',
    mainCatUid: '0',
    mainCatCode: '',
    mainCatName: '',
    categoryUid: '0',
    categoryCode: '',
    categoryName: '',
    weight: '',
    pawnValue: '',
    newPawnValue: '',
    tmpPawnValue: '',
    tmpNewPawnValue: '',
    fullValue: '',
    diamondQuantity: '',
    quantity: '',
    unitUid: '0',
    unitName: '',
    remark: '',
    collateralGroupUid: '',
    version: '',
    serialNumber: '',
      priorityCatUid: '',
  priorityCatCode: '',
  priorityCatName: '',
  };
}


async function update() {

  if (collect_detail.value.unitUid !== '' && collect_detail.value.unitUid !== '0') {
    collect_detail.value.unitName = filterUnit(collect_detail.value.unitUid)
  }

  if (collect_detail.value.mainCatUid !== '' && collect_detail.value.mainCatUid !== '0') {
    let ll = filterMainCat(collect_detail.value.mainCatUid)
    if (ll !== null) {
      collect_detail.value.mainCatCode = ll.code
      collect_detail.value.mainCatName = ll.name
      // console.log('ll : ' + JSON.stringify(ll.code) + ' ' + JSON.stringify(ll.name));
    }

  }

  if (collect_detail.value.fullValue === '') {
    collect_detail.value.fullValue = 0
  }

  if (collect_detail.value.diamondQuantity === '') {
    collect_detail.value.diamondQuantity = 0
  }

  if (collect_detail.value.weight === '') {
    collect_detail.value.weight = 0
  }

  if (selected.value === '' && collect_detail.value.mainCatName !== 'อื่นๆ') {
    let sl = types.value.filter((c) => c.fullName.toLowerCase().indexOf(filterText.value.trim().toLowerCase()) >= 0);
    if (sl.length > 0) {
      selected.value = sl[0]
    }
  }

  if (selected.value !== '') {
    let ld = types.value.filter((c) => c.uid.toLowerCase().indexOf(selected.value.uid.toLowerCase()) >= 0);
    if (ld.length > 0) {
      if (ld[0].name !== 'อื่นๆ') {
        collect_detail.value.categoryUid = ld[0].uid
        collect_detail.value.categoryCode = ld[0].code
        collect_detail.value.categoryName = ld[0].fullName
      } else {
        collect_detail.value.categoryUid = ''
        collect_detail.value.categoryCode = ''
        collect_detail.value.categoryName = filterText.value.trim()
      }
    } else {
      collect_detail.value.categoryUid = ''
      collect_detail.value.categoryCode = ''
      collect_detail.value.categoryName = ''
    }
  } else {

    if (collect_detail.value.mainCatName === 'อื่นๆ') {
      collect_detail.value.categoryUid = ''
      collect_detail.value.categoryCode = ''
      collect_detail.value.categoryName = filterText.value.trim()
      await loadAssetList(collect_detail.value.mainCatUid)
      if (tplist.value.length > 0) {
        // console.log('tplist : ' + JSON.stringify(tplist.value));
        let ld = tplist.value.filter((c) => c.name.toLowerCase().indexOf('อื่นๆ') >= 0);
        if (ld.length > 0) {
          collect_detail.value.categoryUid = ld[0].uid
          collect_detail.value.categoryCode = ld[0].code
          collect_detail.value.categoryName = filterText.value.trim()
        }
      }
    } else {
      collect_detail.value.categoryUid = ''
      collect_detail.value.categoryCode = ''
      collect_detail.value.categoryName = filterText.value.trim()
    }
  }

  collect_detail.value.weight = parseFloat(collect_detail.value.weight)
  collect_detail.value.newPawnValue = parseFloat(collect_detail.value.newPawnValue)
  collect_detail.value.pawnValue = parseFloat(collect_detail.value.newPawnValue)
  collect_detail.value.tmpPawnValue = parseFloat(collect_detail.value.newPawnValue)
  collect_detail.value.tmpNewPawnValue = parseFloat(collect_detail.value.newPawnValue)
  collect_detail.value.fullValue = parseFloat(collect_detail.value.fullValue)
  collect_detail.value.diamondQuantity = parseInt(collect_detail.value.diamondQuantity)
  collect_detail.value.quantity = parseInt(collect_detail.value.quantity)

  if (collect_detail.value.unitUid === '0') {
    collect_detail.value.unitUid = ''
    collect_detail.value.unitName = ''
  }

  // console.log('update : ' + JSON.stringify(collect_detail.value));

  wanninglist.value = []
  if (collect_detail.value.serialNumber !== '' && collect_detail.value.serialNumber !== null) {
    await findsanctionAsset(collect_detail.value.serialNumber)
    if (wanninglist.value.length > 0) {
      const myModal = document.getElementById('searchSanctionModal');
      const modal = new Modal(myModal); // Instantiates your modal
      modal.show();
    } else {
      if (listcat_order.value.length === 0) {
          await loadDataOrderCatApi()
      }
      updateItems()
      clearItem()
    }
  } else {
    if (listcat_order.value.length === 0) {
          await loadDataOrderCatApi()
    }
    updateItems()
    clearItem()
  }



}


function filterMainCat(str) {
  let name = listprint.value.filter((c) => c.uid === str);
  return name[0];
}

function filterUnit(str) {
  let name = listunit.value.filter((c) => c.uid === str);
  return name[0].name;
}

async function updateItems() {
  let min = ''
  let catUid = '0'
  let catCode = ''
  let catName = ''
  if (listcat_order.value.length > 0) {
    let collList = listQ02D.value
    for (let i = 0; i < collList.length; i++) {
      if (collList[i].uid === collect_detail.value.uid) {
            collList[i].mainCatUid = collect_detail.value.mainCatUid
            collList[i].mainCatCode = collect_detail.value.mainCatCode
            collList[i].mainCatName = collect_detail.value.mainCatName
        break  
      }
      
    }

    for (let i = 0; i < collList.length; i++) {
      let index = listcat_order.value.indexOf(collList[i].mainCatUid);
      if (index >= 0) {
        if (min === '') {
          min = index
          catUid = collList[i].mainCatUid
          catCode = collList[i].mainCatCode
          catName = collList[i].mainCatName
        } else {
          if (index < min) {
            min = index
            catUid = collList[i].mainCatUid
            catCode = collList[i].mainCatCode
            catName = collList[i].mainCatName
          }
        }
      }
    }
  }
  const payload = collect_detail.value;
  payload.remark = payload.remark.trim()
  payload.version = workcaseDetail.value.ticket.version
  payload.priorityCatUid = catUid
  payload.priorityCatCode = catCode
  payload.priorityCatName = catName
  // console.log('updateItems : ' + JSON.stringify(payload));
  const response = await storecl.updateAfterCompleteFetch(payload);
  // console.log('updateItems : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value.ticket.version = response.data.data.version
        swal({
          icon: 'success',
          title: 'บันทึกสำเร็จ',
          text: '',
          target: '#newPawnListModal',
          customClass: {
            container: 'loading-state'
          },
        })
        await getcollateralList();
        await getworkCaseInfo(workcaseDetail.value.uid)
      } else {
        swal({
          icon: 'error',
          title: 'บันทึกไม่สำเร็จ',
          text: response.data.rtnDesc,
          target: '#newPawnListModal',
          customClass: {
            container: 'loading-state'
          },
        })

      }
    }
  }
}

async function getcollateralList() {
  let list = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    tuid: uid_edit.value,
  };
  const payload = data;
  // const response = await store.dispatch("unitListFetch", payload);
  const response = await storecl.collateralListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        list.map(function (x) {
          x.chk = false
          x.remarkL = []
          return x
        });


        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            list[i].remarkL.push({ val: list[i].remark })
          }
        }

        listQ02D.value = list

      }
    }
  }
}


async function findsanctionAsset(serial) {
  // 'abc-123' , 'ccc888'
  let data = "";
  data = {
    serialNumber: serial.trim(),
  };
  const payload = data;
  // console.log("ass : " + JSON.stringify(payload));
  const response = await storeass.sanctionaAssetFetch(payload);
  // console.log("ass : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data !== null) {
          wanninglist.value.push(response.data.data)
          // console.log("ass : " + JSON.stringify(response.data));
        }

      }
    }
  }
}

// Fetch data function
const fetchData = async () => {
  try {
    loading_l.value = true;
    await new Promise(res => setTimeout(res, 500));
    // console.log('typesNew fetch : ' + JSON.stringify(typesNew.value))
    const res = typesNew.value.slice(page_s.value, page_e.value);
    // console.log('res fetch : ' + JSON.stringify(res))
    dataList.value.push(...res);
    page_s.value = page_s.value + res.length;
    page_e.value = page_s.value + limit;
    showSuggestions.value = true;

    let re = String(res.length).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    let ret = String(dataList.value.length).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } catch (error) {
    console.error('Error fetching data:', error);
    loading_l.value = false;
  } finally {
    loading_l.value = false;
  }
};

// Handle scroll event for infinite loading
const handleScroll = () => {
  const scrollContainer = list.value;
  // console.error('scrollTop :', scrollContainer.scrollTop);
  // console.error('clientHeight :', scrollContainer.clientHeight);
  // console.error('scrollHeight :', scrollContainer.scrollHeight);
  if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight) {
    // Reached the bottom of the scroll container, load more data
    if (dataList.value.length <= 10) {
      // console.log("data : " + dataList.value.length);
      scrollContainer.scrollTo(0, 0);
    }

    if (typesNew.value.length > 0) {
      fetchData();
    }

  }
};

// Function to update widths
const updateWidths = () => {
  if (parentRef.value && list.value) {
    parentWidth.value = parentRef.value.clientWidth;
    childWidth.value = parentRef.value.clientWidth;
  }
}
/* eslint-disable no-useless-escape */
const updateText = () => {
  let inp = document.querySelector("#inp");
  let list = document.querySelectorAll('#myList li')
  var filtter = inp.value.trim().replaceAll(">>", " ");
  var text = filtter.toLowerCase().replaceAll("'", " ");
  var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
  var repl = text.replace(invalid, "")
  var arrt = repl.match(/\S+/g);

  if (arrt !== null) {
    const arr = Array.from(list);
    arr.forEach((x) => {
      const txtValue = x.innerText || x.textContent;
      var string = txtValue;

      var finalAns = string;
      for (var i = arrt.length - 1; i >= 0; i--) {
        finalAns = finalAns.replace(
          RegExp(arrt[i], "gi"),
          '<b style="color:orange;">$&</b>'
        );
      }
      x.innerHTML = finalAns;
      x.style.display = "block";
    });
  }
}


function cancelBtn() {
  time.value = false;
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  serial_search.value = '';
  currentPage.value = 1
  listhistory.value = []
  listticketchain.value = []
  totalRows_s.value = ''
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  miref_search.value = ''
  stockno_search.value = ''
  active_search.value = false
  type_search.value = tx_nomitype.value
  search_status.value = status_type.value
  tx_search.value = tx_type.value
  channel_search.value = channel_type.value
  idcard_search.value = idcard_type.value
  otp_search.value = otp_type.value
  represent_search.value = represent_type.value
  outage_search.value = outage_type.value
  maincat_search.value = ''
}

function filterTx() {
  let process = false
  if (tx_search.value.length > 0) {
    // console.log('tx_search : ' + JSON.stringify(tx_search.value));
    let name = tx_search.value.filter((c) => c.code.trim() === 'MIGRATION');
    if (name.length > 0) {
      process = true
    }
  }
  return process
}


function changeTx() {
  // console.log("tx_search : " + tx_search.value);
  if (tx_search.value.length !== tx_type.value.length) {
    let txFilter = ''
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
    if (txFilter.includes("NORMAL")) {
      type_search.value = tx_nomitype.value;
    } else if (txFilter.includes("MIGRATION")) {
      type_search.value = tx_mitype.value;
    } else {
      type_search.value = '';
    }
  } else {
    type_search.value = tx_nomitype.value;
  }

}


function monthDiff() {
  let pro = false
  var months;
  months = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12;
  months += end_date.value.getMonth() - start_date.value.getMonth();

  if (time.value && months > 6) {
    pro = true
  }
  return pro
}

const loadDataHistoryApi = async () => {
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  currentPage.value = 1
  let data = "";
  let sd = ''
  let ed = ''
  let status = ''
 

  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }

  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }




  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value.trim(),
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value.trim(),
    shopUid: shop_detail.value.uid,
    status: status,
    txFilter: txFilter,
    migrateRefNumber: miref_search.value.trim(),
    stockNumber: stockno_search.value.trim(),
    groupUid: shop_detail.value.groupUid,
    active: active_search.value,
    channel: channel,
    catUid: maincat_search.value,
    idCardVerify: idcard,
    otp: otp,
    shopRepresent: represent,
    outage: outage,
  };

  const payload = data;
  // console.log("History p : " + JSON.stringify(payload));
  const response = await storewc.workCaseHistoryFetch(payload);
  // console.log("History r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}




const loadDataPrintApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        // console.log('Listdata : ' + JSON.stringify(listprint.value))
      }
    }
  }
};


async function getworkCaseInfo(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function getListChain() {
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
    shopUid: shop_detail.value.uid,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getListChain : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
      onClickTab('2')
    }
  }
}

async function calIntInt() {
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}


async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  }
  return side
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}


function containsOnlyNumbers(str){
  return /^\d+$/.test(str);
}

function checkOutage(str,val) { 
  let side = ''
  if (val) {
    if (str === ',') {
      side = str + t("content.outage")
    } else  if (str === '-') {
      side = '('+t("content.outage") + ')'
    }
    
  }
  return side
}


function checkShopRepresent(str,item) { 
  let side = ''
  if (item.outage === false) {
    if (str === ',') {
      side = str + t("content.gchonline")
    } else if (str === '-') {
      side = '(' + t("content.gchonline")
    }
  }

  
  if (containsOnlyNumbers(item.initRefNumber)) {
    if (side === '') {
      if (str === ',') {
          side = ','+t("content.translost")
        } else if (str === '-') {
          side = '('+t("content.translost")
        }
    } else {
      side = side + ','+t("content.translost")
    }
  }

  if (item.outage) {
      if (side === '') {
        if (str === ',') {
            side = str + t("content.outage")
          } else if (str === '-') {
            side = '(' + t("content.outage")
          }
      } else {
        side =  side + ','+t("content.outage")
      }
    }

  if (side !== '' && str === '-') {
    side = side + ')'
  }  

  return side
}

function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}




async function onClickTab(val) {
  if (val === '1') {
    if ((time.value && monthDiff()) || cusName_search.value !== '' && tk_search.value !== '' && serial_search.value !== '') {
      loadDataHistoryApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
  }
}


async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function selectCusAf(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updatePagination() {
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  let sd = ''
  let ed = ''
  let data = "";

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

 let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value.trim(),
    fromDate: sd,
    toDate: ed,
    type: type,
    serialNumber: serial_search.value.trim(),
    shopUid: shop_detail.value.uid,
    status: status,
    txFilter: txFilter,
    migrateRefNumber: miref_search.value.trim(),
    stockNumber: stockno_search.value.trim(),
    groupUid: shop_detail.value.groupUid,
    active: active_search.value,
    channel: channel,
    catUid: maincat_search.value,
    idCardVerify: idcard,
    otp: otp,
    shopRepresent: represent,
    outage: outage,
  };

  const payload = data;
  const response = await storewc.workCaseHistoryFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        listhistory.value = []
        totalRows.value = 0
        totalRows_s.value = ''
      } else {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function updatePaginationT() {
  listticketchain.value = []
  let data = "";
  data = {
    index: currentPageT.value - 1,
    size: perPageT.value,
    uid: chain_uid.value,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listticketchain.value = response.data.data.list;
        totalRowsT.value = response.data.data.ext.total
        totalRows_sT.value = formatNumberString(totalRowsT.value)
      }
    }
  }

}



async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  const response = await storecus.searchCustomerFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


function setGallery() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo1").innerHTML = y;
}


async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  info_cat.value = ''
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }


    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          await retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      await calIntInt()
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();

    }
  }
}

async function openListChain(item) {
  chain_uid.value = item.uid
  currentPageT.value = 1
  listticketchain.value = []
  await getListChain()
}


async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}


async function getTicketImage() {
  if (images.value.length === 0) {
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }
    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        setGallery()
        document.getElementById("detailModal").click();
      } else {
        let obj = {
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        }
        images.value.push(obj)
        setGallery()
        document.getElementById("detailModal").click();
      }
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      setGallery()
      document.getElementById("detailModal").click();
    }
  } else {
    setGallery()
    document.getElementById("detailModal").click();
  }
}


async function getFile(urls) {
  let file_L = []
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
  const requests = urls.map((url) => axios.get(url));
  await Promise.all(requests).then(allResults => {
    if (allResults) {
      file_L = allResults
      if (file_L !== null) {
        for (let i = 0; i < file_L.length; i++) {
          // console.log('file_L : ' + JSON.stringify(file_L[i].data));
          if (file_L[i].data.data !== null) {
            const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
            const data = URL.createObjectURL(file);
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: ''
            }
            images.value.push(obj)
          }
        }
      }
    }
  })

}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function ticketGen(item) {
  let uids = []
  uids.push(item.uid)
  await getticketNew(uids)
}

async function backCoverGen(item) {
  let uids = []
  uids.push(item.uid)
  await getbackcoverNew(uids)
}

async function replaceTicketGen(item) {
  await checkChain(item)
}

async function getticketNew(id) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function getbackcoverNew(id) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/backCover/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function getreplaceTicketNew(id) {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/replace/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function addfileApi(image) {
  thumb_id.value = ""
  let data = "";
  let trimmedString = String(image.filedt).replace(regex, "")

  data = {
    name: image.fname,
    data: trimmedString,
    mimeType: image.ftype
  };

  const payload = data;
  // console.log('addfileApi p : ' + JSON.stringify(payload));
  const response = await stored.addFetch(payload);
  // console.log('addfileApi r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        err_msg.value = response.data.rtnDesc
      } else {
        thumb_id.value = response.data.data.uid
        if (thumb_id.value !== '') {
          await addTicketImage()
        }
      }
    }
  }
}

async function addTicketImage() {
  let data = "";
  data = {
    ticketUid: uid_edit.value, // always required
    uid: "0",
    imageUid: thumb_id.value,
    remark: "",
    version: "0"
  };

  const payload = data;
  const response = await storeti.ticketImageNewFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        err_msg.value = response.data.rtnDesc
      } else {
        count_success.value = Number(count_success.value) + 1
      }
    }
  }
}


const loadAssetList = async (uid) => {
  tplist.value = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    uid: uid,
  };

  const payload = data;
  const response = await storec.categoryListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        tplist.value = response.data.data.list
      }
    }
  };
}

async function loadDataOrderCatApi() {
  listcat_order.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: shop_detail.value.uid
  };

  const payload = data;
  const response = await storeco.shopCatOrderListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        if (list.length !== 0) {
          listcat_order.value = list[0].catOrders
          listcat_order.value = Object.values(listcat_order.value)
          // console.log('listcat_order : ' + listcat_order.value);
        }
      }
    }
  }
}


async function setFileGallery() {
  if (images.value.length === 0) {
    loading.value = true
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }

    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        loading.value = false
        document.getElementById("attachmenDialog").click();
      }
    } else {
      loading.value = false
      document.getElementById("attachmenDialog").click();
    }

  } else {
    loading.value = false
    document.getElementById("attachmenDialog").click();
  }
}

async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: shop_detail.value.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


async function XlsxGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }


  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  data = {
    page: {
      index: "0",
      size: "0", // size=0 (default) = no page limit
      sort: ""
    },
    filter: {
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      fromDate: sd,
      toDate: ed,
      type: type,
      serialNumber: serial_search.value.trim(),
      shopUid: shop_info.value.uid,
      status: status,
      txFilter: txFilter,
      migrateRefNumber: miref_search.value.trim(),
      stockNumber: stockno_search.value.trim(),
      groupUid: shop_info.value.groupUid,
      active: active_search.value,
      shopName: shop_info.value.fullname,
      channel: channel,
      catUid: maincat_search.value,
      idCardVerify: idcard,
      otp: otp,
      shopRepresent: represent,
      outage: outage,
    }
  };

  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/workCase/history/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = `rpHistory_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function pdfGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''

  if (time.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  let status = ''
  if (search_status.value.length !== status_type.value.length) {
    for (let i = 0; i < search_status.value.length; i++) {
      if (status === '') {
        status = search_status.value[i].code.trim()
      } else {
        status = status + ',' + search_status.value[i].code.trim()
      }
    }
  }


  let txFilter = ''

  if (tx_search.value.length !== tx_type.value.length) {
    for (let i = 0; i < tx_search.value.length; i++) {
      if (txFilter === '') {
        txFilter = tx_search.value[i].code.trim()
      } else {
        txFilter = txFilter + ',' + tx_search.value[i].code.trim()
      }
    }
  }

  let type = ''
  if (txFilter !== '') {
    if (txFilter.includes("MIGRATION")) {
      if (type_search.value.length !== tx_mitype.value.length) {
        for (let i = 0; i < type_search.value.length; i++) {
          if (type === '') {
            type = type_search.value[i].code.trim()
          } else {
            type = type + ',' + type_search.value[i].code.trim()
          }
        }
      }
    } else {
      if (txFilter.includes("NORMAL")) {
        if (type_search.value.length !== tx_nomitype.value.length) {
          for (let i = 0; i < type_search.value.length; i++) {
            if (type === '') {
              type = type_search.value[i].code.trim()
            } else {
              type = type + ',' + type_search.value[i].code.trim()
            }
          }
        }
      }
    }
  } else {
    if (type_search.value.length !== tx_nomitype.value.length) {
      for (let i = 0; i < type_search.value.length; i++) {
        if (type === '') {
          type = type_search.value[i].code.trim()
        } else {
          type = type + ',' + type_search.value[i].code.trim()
        }
      }
    }
  }

  let channel = ''
  if (channel_search.value.length !== channel_type.value.length) {
    for (let i = 0; i < channel_search.value.length; i++) {
      if (channel === '') {
        channel = channel_search.value[i].code.trim()
      } else {
        channel = channel + ',' + channel_search.value[i].code.trim()
      }
    }
  }

  let idcard = 'NONE'
  if (idcard_search.value.length !== idcard_type.value.length) {
    if (idcard_search.value[0].code.trim() === idcard_type.value[0].code.trim()) {
      idcard = 'TRUE'
    } else if (idcard_search.value[0].code.trim() === idcard_type.value[1].code.trim()) {
      idcard = 'FALSE'
    }
  }

  let otp = 'NONE'
  if (otp_search.value.length !== otp_type.value.length) {
    if (otp_search.value[0].code.trim() === otp_type.value[0].code.trim()) {
      otp = 'TRUE'
    } else if (otp_search.value[0].code.trim() === otp_type.value[1].code.trim()) {
      otp = 'FALSE'
    }
  }

  let represent = 'NONE'
  if (represent_search.value.length !== represent_type.value.length) {
    if (represent_search.value[0].code.trim() === represent_type.value[0].code.trim()) {
      represent = 'TRUE'
    } else if (represent_search.value[0].code.trim() === represent_type.value[1].code.trim()) {
      represent = 'FALSE'
    }
  }


  let outage = 'NONE'
  if (outage_search.value.length !== outage_type.value.length) {
    if (outage_search.value[0].code.trim() === outage_type.value[0].code.trim()) {
      outage = 'TRUE'
    } else if (outage_search.value[0].code.trim() === outage_type.value[1].code.trim()) {
      outage = 'FALSE'
    }
  }

  data = {
    page: {
      index: "0",
      size: "0", // size=0 (default) = no page limit
      sort: ""
    },
    filter: {
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      fromDate: sd,
      toDate: ed,
      type: type,
      serialNumber: serial_search.value.trim(),
      shopUid: shop_info.value.uid,
      status: status,
      txFilter: txFilter,
      migrateRefNumber: miref_search.value.trim(),
      stockNumber: stockno_search.value.trim(),
      groupUid: shop_info.value.groupUid,
      active: active_search.value,
      shopName: shop_info.value.fullname,
      channel: channel,
      catUid: maincat_search.value,
      idCardVerify: idcard,
      otp: otp,
      shopRepresent: represent,
      outage: outage,
    }
  };

  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/workCase/history/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
  if (response.headers.get("content-type") === 'application/pdf') {

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
        transdate_prv.value = workcase_prv.workItems[0].startTime

      }
    }
  }
}


async function calIntIntPrv() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail_prv.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail_prv.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = ""
  let pawnValue = workcaseDetail.value.pawnValue

  data = {
    pawnDate: '',
    previousTxDate: moment(workcaseDetail_prv.value.workItems[0].startTime).format('YYYY-MM-DD'),
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail_prv.value.promotionUid,
    interestUid: workcaseDetail_prv.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}


async function checkChain(item) {
  let list = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    uid: item.uid,
    shopUid: shop_detail.value.uid,
  };
  const payload = data;

  const response = await storewc.workCaseListChainFetch(payload);
  // console.log("getListChain : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        if (list.filter((c) => c.type === 'REDEEM').length > 0) {
          swal("ไม่สามารถพิมพ์รายการนี้ได้ เนื่องจากตั๋วนี้ได้ถูกไถ่ถอนไปแล้ว", "", "error");
        } else {
          if (item.deposit) {
            await replaceTicketDialog(item)
          } else {
            let uids = []
            uids.push(item.uid)
            await getreplaceTicketNew(uids)
          }
        }
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}


async function replaceTicketDialog(item) { 
    swal({
    title: "ตั๋วใบนี้ได้ถูกฝากไว้ในระบบแล้ว",
    text: "",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('content.printrepltk'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      let uids = []
      uids.push(item.uid)
      getreplaceTicketNew(uids)
    }
   });
}


async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }
  data = {
    cusUid : item.customerInfo.customerUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}


onUpdated(() => {
  updateWidths();
  updateText()

})

onMounted(() => {
  updateWidths();
  window.addEventListener('resize', updateWidths);

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 20px !important;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}

</style>
